import { render, staticRenderFns } from "./LabelledInputText.vue?vue&type=template&id=78b59477&scoped=true&"
import script from "./LabelledInputText.vue?vue&type=script&lang=js&"
export * from "./LabelledInputText.vue?vue&type=script&lang=js&"
import style0 from "./LabelledInputText.vue?vue&type=style&index=0&id=78b59477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b59477",
  null
  
)

export default component.exports